import { useContext } from "react"
import type { Dispatch } from "react"
import type { Layout } from "react-grid-layout"
import type { EntityType } from "types/common.types"
import type { StaticPlotDef, QueryPlotDef } from "types/dashboard.types"
import type { LayoutActionT } from "helpers/reducers/dashboardReducers"
import DashboardContext from "helpers/contexts/DashboardContext"

interface DashboardContextReturn {
  config: {
    type: string
    plotDefs: (StaticPlotDef | QueryPlotDef)[]
  } | null
  plotLayout: Record<string, Layout> | null
  dispatchPlotLayout: Dispatch<LayoutActionT> | null
  rowHeight: number | null
  entityType: EntityType | null
}

export const useDashboardContext = (): DashboardContextReturn => {
  const context = useContext(DashboardContext)

  if (!context) {
    return {
      config: null,
      plotLayout: null,
      dispatchPlotLayout: null,
      rowHeight: null,
      entityType: null,
    }
  }

  return {
    config: context.config,
    plotLayout: context.plotLayout ?? null,
    dispatchPlotLayout: context.dispatchPlotLayout ?? null,
    rowHeight: context.rowHeight ?? null,
    entityType: context.entityType,
  }
}
